import { Icon } from '@iconify/react'

import s from './PageUrl.module.css'

type Props = {
  url: string
  domainName?: string
}

export const PageUrl = ({ url, domainName = '' }: Props) => {
  const trimmedUrl = url
    .replace(/(https:\/\/)|(www\.)/g, '')
    .replace(domainName, '')

  return (
    <a
      className={s.pageUrl}
      href={`https://${url.replace('https://', '')}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      <span className={s.pageUrlText}>{trimmedUrl}</span>
      <Icon className={s.pageUrlIcon} icon="lucide:external-link" />
    </a>
  )
}
